import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import { SegmentContext, SegmentListService } from "go-segment/context";
import { partnerApiSegment } from "../../../../services/Api/Partner/partnerApiSegment";
import PartnerDashboardPage from "./pages/Dashboard";
import PartnerLoansExternalPage from "./pages/LoansExternal";
import PartnerPreviewPage from "./pages/Preview";

const PartnerPage = (props: RouteComponentProps) => {
	const segmentPath = `/admin/segments`;
	const { addFlash } = useFlash();

	return (
		<SegmentContext.Provider
			value={
				new SegmentListService(
					{
						saveSegment: partnerApiSegment.saveSegment,
						removeSegment: partnerApiSegment.removeSegment,
						getSegments: partnerApiSegment.getSegments,
						restoreSegment: partnerApiSegment.restoreSegment,
						updateSegment: partnerApiSegment.updateSegment,
						updateSegments: partnerApiSegment.updateSegments,
						setAsDefault: partnerApiSegment.setSegmentAsDefault,
						setNotDefault: partnerApiSegment.setSegmentNotDefault,
					},
					segmentPath,
					partnerApiSegment.getListInfo,
					addFlash
				)
			}
		>
			<Switch>
				<Route path={`${props.match.url}/loans`} component={PartnerLoansExternalPage} />
				<Route path={`${props.match.url}/:partnerId`} component={PartnerPreviewPage} />
				<Route exact path={`${props.match.url}/`} component={PartnerDashboardPage} />
			</Switch>
		</SegmentContext.Provider>
	);
};

export default PartnerPage;
